import { render, staticRenderFns } from "./ClientProjectSteps.vue?vue&type=template&id=b7feb25a&scoped=true&"
import script from "./ClientProjectSteps.vue?vue&type=script&lang=ts&"
export * from "./ClientProjectSteps.vue?vue&type=script&lang=ts&"
import style0 from "./ClientProjectSteps.vue?vue&type=style&index=0&id=b7feb25a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7feb25a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
